import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6123574a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "distribution-groups-wrapper",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "distribution-groups-title grid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-title col-3 mt-3" }, "選定ユーザー一覧")
], -1))
const _hoisted_3 = { class: "target-customer-list-body mt-3" }
const _hoisted_4 = { class: "p-input-icon-left h-auto box-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { class: "list-groups mt-3" }
const _hoisted_7 = { class: "w-full text-right pr-3" }
const _hoisted_8 = { class: "grid mt-3 justify-content-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "指定したユーザーを除外設定しますか?")
], -1))
const _hoisted_10 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, onBeforeMount, computed } from "vue";
// Vue関連のインポート
import { get, set } from "@vueuse/core";

// サードパーティライブラリのインポート
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { PageState } from "primevue/paginator";

// PrimeVueコンポーネントのインポート
import Toast from "primevue/toast";
import Checkbox from "primevue/checkbox";

// 子コンポーネントのインポート
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";

// サービス・ユーティリティのインポート
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import DistributionGroupService from "@/clinic/services/distribution_group_service";

// 定数・型定義のインポート
import { DEFAULT_MEDIUM_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import { ApiBasePaginatorReq, ICustomer } from "@/clinic/typings";
import { BasicCustomerFilterFields } from "@/clinic/typings/enums/customer";

/**
 * Vuexストア
 * @type {Store}
 */
type IColumn = {
  /** フィールド名 */
  field: string;
  /** ヘッダー名 */
  header: string;
  /** CSSクラス */
  class?: string;
  /** インラインスタイル */
  style?: string;
  /** アイコン */
  icon?: any;
};
/**
 * 検索処理
 * @param {Event} event - 検索イベント
 */
enum LineLinkedClassEnum {
  true = "icon-lms icon-lms_link text-line-green mx-auto",
}
/**
 * グリッドカラム定義
 * @type {Ref<IColumn[]>}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TargetCustomers',
  props: {
    distributionGroupId: null,
    targetCustomers: null
  },
  emits: ["resourcesFn", "changeTargetViewType", "setRejectedCustomerIds"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** 配信グループID */
  distributionGroupId: string | number;
  /** ターゲット顧客リスト */
  targetCustomers: any[];
};

/**
 * ターゲット顧客一覧コンポーネント
 *
 * このコンポーネントは配信グループのターゲット顧客一覧を表示し、
 * 以下の機能を提供します：
 * - 顧客検索
 * - 顧客一覧表示
 * - 顧客除外機能
 * - ページネーション
 *
 * @component TargetCustomers
 * @description 配信グループのターゲット顧客一覧を管理するコンポーネント
 */

// Vue関連のインポート
const store = useStore();

/**
 * トースト通知
 * @type {UseToast}
 */
const toast = useToast();

/**
 * 最初のレコードのインデックス
 * @type {Ref<number>}
 */
const first = ref(0);

/**
 * 1ページあたりのレコード数
 * @type {Ref<number>}
 */
const rows = ref(DEFAULT_MEDIUM_PAGINATOR_ROWS);

/**
 * 総レコード数
 * @type {Ref<number>}
 */
const totalCount = ref(0);

/**
 * 現在のページ番号
 * @type {Ref<number>}
 */
const page = ref(0);

/**
 * 上部ページネーターの参照
 * @type {Ref<InstanceType<typeof Paginator> | null>}
 */
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);

/**
 * 下部ページネーターの参照
 * @type {Ref<InstanceType<typeof Paginator> | null>}
 */
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);

/**
 * 除外確認ダイアログの表示フラグ
 * @type {Ref<boolean>}
 */
const visible = ref(false);

/**
 * ターゲット顧客リスト
 * @type {Ref<any[]>}
 */
const targetCustomers = ref<any[]>([]);

/**
 * 検索キーワード
 * @type {Ref<string>}
 */
const searchTerm = ref("");

/**
 * ローディング状態
 * @type {Ref<boolean>}
 */
const loading = ref(false);

/**
 * 選択された顧客のリスト
 * @type {Ref<any[]>}
 */
const listChosen = ref<any[]>([]);

/**
 * クリニックID
 * @type {Ref<number>}
 */
const clinicId = ref(0);
/**
 * カラム定義の型
 * @type {Object}
 */
const onSearch = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  set(searchTerm, target.value);
  if (page.value !== 0) {
    await paging("", { page: 0 } as PageState);
  } else {
    await loadCustomers();
  }
};

/**
 * イベントエミッター
 */


/**
 * ターゲット設定に戻る処理
 */
const onBackToTargetSetting = () => {
  emits("resourcesFn", 2);
  emits("changeTargetViewType", "setting");
};

/**
 * ページネーター用パラメータ
 * @type {ComputedRef<ApiBasePaginatorReq>}
 */
const paginatorParams = computed(
  (): ApiBasePaginatorReq => ({ term: get(searchTerm), page: get(page) + 1, rows: get(rows) } as ApiBasePaginatorReq)
);

/**
 * ページネーション処理
 * @param {string} fromId - ページネーション元ID
 * @param {PageState} pageState - ページ状態
 */
const paging = async (_fromId: string, { page: newPage }: PageState) => {
  if (newPage === page.value) return;

  // ページ番号の範囲チェック
  const totalPages = Math.ceil(get(totalCount) / get(rows));
  if (newPage < 0 || newPage >= totalPages) {
    console.warn(`無効なページ番号: ${newPage}, 総ページ数: ${totalPages}`);
    return;
  }

  set(page, newPage);
  await loadCustomers();
};

/**
 * 顧客データの読み込み
 */
const loadCustomers = async () => {
  try {
    set(loading, true);
    const params = {
      clinic_id: clinicId.value,
      ...get(paginatorParams),
      filter_by: BasicCustomerFilterFields,
    };
    const { data } = await DistributionGroupService.getTargetCustomers(props.distributionGroupId, params);
    const { customers: customersData, meta } = get(data);
    const { total_count } = meta;
    set(
      targetCustomers,
      get(customersData).map((cus: any) => {
        return {
          ...cus,
          address: `${cus.address || ""} ${cus.address_number || ""}`,
          linked_line: (cus?.line_account_ids || []).length != 0,
        } as unknown as ICustomer;
      })
    );
    set(totalCount, get(total_count));
  } catch (error) {
    console.error("顧客データ取得エラー:", error);
    // エラーが発生した場合は現在のページを維持し、データは変更しない
  } finally {
    set(loading, false);
  }
};

/**
 * ターゲット顧客の除外処理
 */
const onDeleteTargetCustomers = async () => {
  const params = {
    clinic_id: clinicId.value,
    customer_ids: listChosen.value,
  };
  await DistributionGroupService.deleteTargetCustomers(
    props.distributionGroupId,
    params,
    () => {
      notifySuccessMsg(toast, "指定したユーザーを除外しました");
      set(visible, false);
      loadCustomers();
      emits("setRejectedCustomerIds", listChosen.value);
      listChosen.value = [];
    },
    () => notityErrorMsg(toast, "エラーが発生しました")
  );
};

/**
 * コンポーネントのプロパティ定義
 * @type {Object}
 */


/**
 * LINE連携状態のクラス定義
 * @type {Object}
 */
const columns = ref<IColumn[]>([
  { field: "action", header: "", class: "col-1", style: "font-size: 13px; width: 60px" },
  { field: "code", header: "カルテNo.", class: "col-1", style: "width: 90px" },
  {
    field: "linked_line",
    header: "LINE紐付け",
    class: "col-1 text-center",
    style: "white-space:nowrap",
    icon: LineLinkedClassEnum,
  },
  { field: "name", header: "名前", class: "col-2" },
  { field: "phone", header: "電話番号", class: "col-2" },
  { field: "address", header: "住所" },
  { field: "comment", header: "メモ" },
]);
const onClosedDialog = () => {
  set(visible, false);
};
/**
 * アイテムクリック処理
 * @param {any} event - クリックイベント
 * @param {any} item - クリックされたアイテム
 */
const onItemClick = async (_event: any, _item: any) => {
  // Implement later
};

/**
 * コンポーネントマウント前の処理
 */
onBeforeMount(async () => {
  const currentClinicId = await store.dispatch("authClient/getClinicIdCookie");
  set(clinicId, currentClinicId);
  await loadCustomers();
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          placeholder: "カルテNo.、お名前",
          onKeyup: _withKeys(onSearch, ["enter"]),
          modelValue: searchTerm.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event))
        }, null, 8, ["onKeyup", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Grid, {
          items: targetCustomers.value,
          columns: columns.value,
          loading: loading.value,
          onOnItemClick: onItemClick
        }, {
          action: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(Checkbox), {
                modelValue: listChosen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((listChosen).value = $event)),
                inputId: data.code,
                name: data.code,
                value: data.code
              }, null, 8, ["modelValue", "inputId", "name", "value"])
            ])
          ]),
          _: 1
        }, 8, ["items", "columns", "loading"]),
        _createVNode(Paginator, {
          id: "pg-bot",
          ref_key: "pgBot",
          ref: pgBot,
          modelValue: first.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((first).value = $event)),
          onPaging: paging,
          totalRecords: totalCount.value,
          rows: rows.value,
          class: "mt-2"
        }, null, 8, ["modelValue", "totalRecords", "rows"]),
        _createVNode(_unref(Toast), { position: "top-center" })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Button, {
          class: "col-2 temp-delete-btn ml-5",
          label: "指定ユーザーを除外する",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = true)),
          disabled: listChosen.value.length == 0
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          class: "col-2 create-btn ml-5",
          label: "確認完了・戻る",
          onClick: onBackToTargetSetting
        })
      ]),
      _createVNode(_component_Dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
        modal: "",
        class: "mx-5 dialog-note border-0",
        draggable: false
      }, {
        header: _withCtx(() => [
          _hoisted_9
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button p-button-light mr-3 ml-5",
              onClick: onClosedDialog
            }),
            _createVNode(_component_Button, {
              label: "外して戻る",
              class: "p-button confirm-delete-btn mr-2 ml-4",
              onClick: onDeleteTargetCustomers
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}
}

})